import React, { JSX } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../contexts/UserProvider";

type TProtectedRouteProps =
  | {
      outlet: JSX.Element;
      operatorOnly: boolean;
      adminOnly?: never;
    }
  | {
      outlet: JSX.Element;
      operatorOnly?: never;
      adminOnly: boolean;
    };

export default function ProtectedRoute(props: TProtectedRouteProps) {
  const { outlet, operatorOnly, adminOnly } = props;
  const location = useLocation();
  const { user } = useUser();

  if (user === undefined) {
    return null;
  }

  if (user) {
    if (
      (!operatorOnly && !adminOnly) ||
      (operatorOnly && user.is_operator) ||
      user.is_admin
    ) {
      return outlet;
    }
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  const url = location.pathname + location.search + location.hash;
  return <Navigate to="/login" state={{ next: url }} />;
}
